import './polyfills.ts';
import 'reflect-metadata';

import { ErrorHandler, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';
import { GlobalErrorHandler } from './globalErrorHandler';

if (process.env.RAILS_ENV !== 'development') {
  enableProdMode();
}

platformBrowserDynamic([{ provide: ErrorHandler, useClass: GlobalErrorHandler }])
  .bootstrapModule(AppModule)
  .then(moduleRef => {
    const handler = moduleRef.injector.get(ErrorHandler);
    (window as unknown as { __errorHandler?: ErrorHandler }).__errorHandler = handler;
  })
  .catch(err => console.error(err));

const windowRef = window as unknown as { __clientErrorCount?: number };

function postClientError(payload: Record<string, unknown>): void {
  windowRef.__clientErrorCount = (windowRef.__clientErrorCount || 0) + 1;
  if (windowRef.__clientErrorCount > 5) {
    return;
  }

  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content');

  fetch('/exceptions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
    },
    credentials: 'same-origin',
    keepalive: true,
    body: JSON.stringify(payload),
  }).catch(() => {
    // Swallow errors to avoid recursive failures.
  });
}

window.onerror = function (message, source, lineno, colno, error) {
  console.error('Global window.onerror:', message, error);

  postClientError({
    type: 'window.onerror',
    message,
    source,
    lineno,
    colno,
    error: error ? { name: error.name, message: error.message, stack: error.stack } : null,
    url: location.href,
  });
};

window.addEventListener('unhandledrejection', function (event) {
  console.error('Global Promise rejection:', event.reason);

  postClientError({
    type: 'unhandledrejection',
    reason: event.reason
      ? { name: event.reason.name, message: event.reason.message, stack: event.reason.stack }
      : event.reason,
    url: location.href,
  });
});
